import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd, NavigationError } from '@angular/router';
import { LoadingService } from './_services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    loadingService: LoadingService,
    private router: Router) {

    this.loadingService = loadingService;

    this.loadingRouterControl();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initLoadingService();

      this.router.events.subscribe((evt) => {
        window.scrollTo(0, 0)
      });
    }
  }

  loading: boolean = false;
  loadingService: LoadingService;
  loadingSubscription: any;

  initLoadingService() {
    this.loadingSubscription = this.loadingService.getEmittedValue()
      .subscribe(item => {
        this.loading = item
      });
  }

  loadingRouterControl() {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event) => {
        switch (true) {
          case event instanceof NavigationStart: {
            this.loading = true;
            break;
          }
          case event instanceof NavigationCancel:
          case event instanceof NavigationEnd:
          case event instanceof NavigationError: {
            this.loading = false;
            window.scrollTo(0, 0);
            break;
          }
          default: {
            break;
          }
        }
      });
    }
  }
}
